import gql from 'graphql-tag';

import taskFragment from '../fragments/taskFragment';

export const mutationCreateTask = gql`
  mutation createTask (
    $name: String!
    $description: String
    $sourceDokkioObjectID: DokkioID!
    $dueAt: DateTime
    $rowCreateMethod: TaskRowCreateMethod!
  ) {
    createTask (
      name: $name
      description: $description
      sourceDokkioObjectID: $sourceDokkioObjectID
      dueAt: $dueAt
      rowCreateMethod: $rowCreateMethod
    ) {
      ...taskFragment
    }
  }
  ${taskFragment}
`;
export default mutationCreateTask;
